import { ListenableEvent } from "../utils";
import { ERR_INVALID_ARGUMENT } from "../utils/error";
import { LengthUnit } from "../utils/number";
import { isNullOrEmpty } from "../utils/string";
var I18nManager = /** @class */ (function () {
    function I18nManager() {
        this.eventLocaleChanged = new ListenableEvent(this);
        this.eventLanguageChanged = new ListenableEvent(this);
        this.eventLengthUnitChanged = new ListenableEvent(this);
        this.mLocale = "en-US";
        this.mLanguage = "en";
        this.mLengthUnit = LengthUnit.Meter;
    }
    Object.defineProperty(I18nManager.prototype, "locale", {
        get: function () {
            return (this.mLocale);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nManager.prototype, "language", {
        get: function () {
            return (this.mLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nManager.prototype, "lengthUnit", {
        get: function () {
            return (this.mLengthUnit);
        },
        enumerable: false,
        configurable: true
    });
    I18nManager.prototype.setLocale = function (pLocale) {
        if (isNullOrEmpty(pLocale))
            throw new Error(ERR_INVALID_ARGUMENT);
        this.mLocale = pLocale;
        this.eventLocaleChanged.trigger();
    };
    I18nManager.prototype.setLanguage = function (pLanguage) {
        if (isNullOrEmpty(pLanguage))
            throw new Error(ERR_INVALID_ARGUMENT);
        this.mLanguage = pLanguage;
        this.eventLanguageChanged.trigger();
    };
    I18nManager.prototype.setLengthUnit = function (pUnit) {
        if (pUnit == null)
            return;
        this.mLengthUnit = pUnit;
        this.eventLengthUnitChanged.trigger();
    };
    return I18nManager;
}());
export { I18nManager };
